import "./BusinessesList.css";
import React from "react";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { useEffect } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import getAllPropertiesCountForBusiness from "../../controllers/getAllPropertiesCountForBusiness";
import getAllLeadsCountForBusiness from "../../controllers/getAllLeadsCountForBusiness";
import getAllDealsCountForBusiness from "../../controllers/getAllDealsCountForBusiness";
import getAllAgentsCountForBusiness from "../../controllers/getAllAgentsCountForBusiness";
import getOwnerNameForBusiness from "../../controllers/getOwnerNameForBusiness";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../helpers/stringAvatar";

const BusinessesList = () => {
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "clients"), orderBy("createdAt", "desc"));

    const unsub = onSnapshot(q, (querySnapshot) => {
      let temp = [];
      querySnapshot.forEach(async (businessDoc) => {
        // let pcount = await getAllPropertiesCountForBusiness(businessDoc.id);

        temp.push({
          ...businessDoc.data(),
          id: businessDoc.id,
          name: "",
          properties: 0,
          leads: 0,
          deals: 0,
          agents: 0,
        });
      });

      temp.forEach(async (business) => {
        let properties;
        let leads;
        let agents;
        let deals;
        let ownerName;

        properties = await getAllPropertiesCountForBusiness(business.id);
        leads = await getAllLeadsCountForBusiness(business.id);
        deals = await getAllDealsCountForBusiness(business.id);
        agents = await getAllAgentsCountForBusiness(business.id);
        ownerName = await getOwnerNameForBusiness(business.createdBy);

        setBusinesses((current) =>
          current.map((obj) => {
            if (obj.id === business.id) {
              return {
                ...obj,
                properties: properties,
                leads: leads,
                agents: agents,
                deals: deals,
                name: ownerName,
              };
            }
            return obj;
          })
        );
      });

      setBusinesses(temp);
    });

    return () => {
      unsub();
    };
  }, []);

  return (
    <Fragment>
      <div id="content-body-height" className="content-body business-list">
        <div className="global-body-container">
          <div className="row">
            <div className="col-12">
              <div className="table-striped  table-hover table-borderless mt-2">
                <div className="b-head">
                  <div className="">
                    <h2 className="b-head text-black mb-0 pr-3 f-l">
                      {" "}
                      Businesses
                    </h2>
                  </div>
                </div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Business Name</th>
                      <th>Owner</th>
                      <th>Total Properties</th>
                      <th>Total Agents</th>
                      <th>Total Leads</th>
                      <th>Total Deals</th>
                      <th>Status</th>
                      {/* <th>&nbsp;</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {/* First person */}

                    {businesses !== [] &&
                      businesses?.map((business) => {
                        return (
                          <tr key={business.id} className="alert">
                            <td className="d-flex align-items-center">
                              {/* <div
                                className="img"
                                style={{
                                  backgroundImage: "url(images/person_1.jpg)",
                                }}
                              /> */}

                              {business.image_url ? (
                                <div
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundImage: `url(${business.image_url})`,
                                    backgroundPosition: "center",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                  }}
                                ></div>
                              ) : (
                                <Avatar
                                  {...stringAvatar(business.businessName)}
                                  className="AgentAvatar"
                                />
                              )}
                              <div className="pl-3 client-business">
                                <span>{business.businessName}</span>
                                <span>
                                  {/* Added: {toDateTime(business?.createdAt)} */}

                                  {new Date(
                                    business.createdAt.toDate()
                                  ).toLocaleString()}
                                </span>
                              </div>
                            </td>
                            <td className="owner-name">
                              <span className=" ">{business.name}</span>
                            </td>
                            <td className="total-properties">
                              <span className="number">
                                {business.properties}
                              </span>
                            </td>
                            <td className="total-agents">
                              <span className="number">{business.agents}</span>
                            </td>
                            <td className="total-leads">
                              <span className="number">{business.leads}</span>
                            </td>
                            <td className="total-deals">
                              <span className="number">{business.deals}</span>
                            </td>
                            <td className="status">
                              <span
                                className={`${
                                  business.is_deleted ? "inactive" : "active"
                                }`}
                              >
                                {business.is_deleted ? "Inactive" : "Active"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Log Visitor Popup --> */}
    </Fragment>
  );
};

export default BusinessesList;
